import { createElement } from '../../../core/dom/helpers.js';

/** @type {import('../../../contracts/forms.js').FieldDriver} */
export const hiddenDriver = {
  type: 'hidden',
  mount(container, ctx) {
    const { def } = ctx;

    const input = /** @type {HTMLInputElement} */ (createElement('input', {
      type: 'hidden',
      name: def.key,
    }));
    container.appendChild(input);

    if (ctx.value !== undefined) {
      input.value = ctx.value == null ? '' : String(ctx.value);
    }

    return {
      setValue(value) {
        input.value = value == null ? '' : String(value);
      },
      getValue() {
        return input.value;
      },
      setErrors() {
        // hidden fields don't display errors
      },
      destroy() {
        input.remove();
      },
      clearValue() {
        input.value = '';
      },
    };
  },
};
